import "@fontsource-variable/roboto-flex/opsz.css";
import "./antd.css";
import "./index.css";

import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import ru from "antd/locale/ru_RU";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/Store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// не трогать говной воняет
if (window.location.pathname !== "/login") {
  localStorage.setItem("url", window.location.pathname);
}

root.render(
  <StyleProvider layer>
    <Provider store={store}>
      <BrowserRouter>
        <ConfigProvider
          locale={ru}
          theme={{
            components: {
              Button: {
                colorText: "#3C79FF",
                colorBorder: "#3C79FF",
                borderColorDisabled: "rgba(0, 0, 0, 0.10)",
                defaultHoverBorderColor: "#6B9AFF",
                defaultHoverColor: "#6B9AFF",
              },
              Typography: {
                colorText: "black",
              },
              Tag: {
                defaultColor: "rgba(0, 0, 0, 0.4)",
                defaultBg: "rgb(243, 243, 243)",
              },
              Table: {
                rowHoverBg: "rgba(217, 217, 217, 0.36)",
              },
            },
            hashed: false,
          }}
        >
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>
  </StyleProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
